// extracted by mini-css-extract-plugin
module.exports = {"consent":"styles_consent__3AoaG"};